<!-- <ng-container *ngIf="appComponentData$ | async as appComponentData; else loading"> -->
<main [ngStyle]="{ 'background-image': 'url(' + (backgroundImage | async) + ')' }">
  <app-logo [size]="'bg'" />
  <router-outlet />
</main>
<!-- </ng-container>
<ng-template #loading>
  <app-loader></app-loader>
</ng-template> -->
